import { TradeExecution } from '@/feature/terminal_tables/trade_history/TradeExecution';
import { createHistoryStore } from '@/components/datagrid';
import { Side } from '@/common/constants';

export const useTradeHistoryStore = createHistoryStore<TradeExecution, string>({
  devtoolsName: 'dex-trade-history',
  getKey: (t: TradeExecution) => t.id,
  applyQuickFilter: (row, quick) => {
    if (quick === 'market') return true;
    if (quick === 'buy') return !!row.isBuy;
    if (quick === 'sell') return !row.isBuy;
    return row.side === (quick as Side);
  },
  getMarketId: (row) => row.marketId,
  initialPageSize: 100,
});
